import React, { Component } from "react";

import "./Counter.scss";

class Counter extends Component {
  state = {
    value:
      this.props.value < this.props.min
        ? this.props.min
        : this.props.value || 0,
    min: this.props.min || 0,
    max: this.props.max || -1,
    step: this.props.step || 1,
    stepInput: this.props.stepInput || 1,
    prefix: this.props.prefix || "",
    suffix: this.props.suffix || "",
    currency: this.props.currency || false,
    minDisabled: "",
    maxDisabled: "",
    error: false,
  };

  componentDidMount = () => {
    if (this.state.value === this.state.min) {
      this.setState({ minDisabled: "counter-disabled" });
    }

    if (this.state.value === this.state.max) {
      this.setState({ maxDisabled: "counter-disabled" });
    }
  };

  _onChange = (e) => {
    let newValue = e.target.value;
    // check for empty string or invalid values
    if (newValue === "") {
      this.setState({ value: "" }); // fallback to min value
      this.setState({ error: true });
      this.props.onValueChange(e);
    } else if (newValue > this.state.max && this.state.max !== -1) {
      this.setState({ 
        value: this.state.max, 
        error: true, 
        maxDisabled: "counter-disabled" });
        e.target.value=this.state.max
        this.props.onValueChange(e);
    } else if (newValue < this.state.min ) {
      this.setState({ 
        value: newValue, 
        error: true, 
        minDisabled: "counter-disabled" 
      });
      this.props.onValueChange(e);
    } else if (typeof newValue !== "number") {
      this.setState({ value: newValue });
      this.props.onValueChange(e);

      if (newValue >= this.state.max) {
        this.setState({ maxDisabled: "counter-disabled" });
        this.setState({ value: this.state.max });
      } else {
        this.setState({ maxDisabled: "" });
        this.setState({ minDisabled: "" });
      }

      if (newValue <= this.state.min) {
        this.setState({ minDisabled: "counter-disabled" });
      } else {
        this.setState({ minDisabled: "" });
        this.setState({ maxDisabled: "" });
      }
      this.setState({ error: false });
    }
  };

  _increase = (value) => {
    if (value === "") {
      this.setState({ value: 0 }); // fallback to min value
    } else {
      let parsed = parseFloat(value, 10);

      // if parsed is not a number
      if (isNaN(parsed)) {
        this.setState({ value: 0 }); // fallback to min value
      } else {
        if (value < this.state.max || this.state.max === -1) {
          if (parsed + this.state.step <= this.state.max) {
            this.setState({ value: parsed + this.state.step }, () => {
              let e = { target: { name: null, value: null } };
              e.target.name = this.props.name;
              e.target.value = this.state.value;
              this.props.onValueChange(e);
            }); // increment value
            
            if (parsed + this.state.step >= this.state.max) {
              this.setState({ maxDisabled: "counter-disabled" });
            } else if(parsed + this.state.step < this.state.min)
            { this.setState({ minDisabled: "counter-disabled" });
              this.setState({error: true});
            }else {
              this.setState({ maxDisabled: "" });
              this.setState({ minDisabled: "" });
              this.setState({ error: false });
            }
            
          }
        }
      }
    }
  };

  _decrease = (value) => {
    if (value === "") {
      this.setState({ value: "" }); // fallback to min value
    } else {
      let parsed = parseFloat(value, 10);
      // if parsed is not a number
      if (isNaN(parsed)) {
        this.setState({ value: "" }); // fallback to min value
      } else {
        if (value > this.state.min) {
          if (parsed - this.state.step >= this.state.min) {
            this.setState({ value: parsed - this.state.step }, () => {
              let e = { target: { name: null, value: null } };
              e.target.name = this.props.name;
              e.target.value = this.state.value;
              this.props.onValueChange(e);
            }); // decrement value

            if (parsed - this.state.step <= this.state.min) {
              this.setState({ minDisabled: "counter-disabled" });
            } else {
              this.setState({ minDisabled: "" });
              this.setState({ maxDisabled: "" });
            }
            this.setState({ error: false });
          }
        }
      }
    }
  };

  render() {
    const {
      minDisabled,
      maxDisabled,
      prefix,
      suffix,
      stepInput,
      value,
    } = this.state;
    let { name } = this.props;
    let withPrefix = prefix !== "" ? " counter-with_prefix" : "";
    let withSuffix = suffix !== "" ? " counter-with_suffix" : "";
    let error = this.state.error ? " error-counter" : "";

    return (
      <div className={"counter" + error}>
        <div
          className={"counter-decrease " + minDisabled}
          onClick={() => {
            this._decrease(value);
          }}
        >
          <span>-</span>
        </div>

        <div className="counter-input">
          <i>{prefix}</i>
          <input
            className={"counter-value" + withPrefix + withSuffix}
            name={name}
            type="number"
            step={stepInput}
            onChange={this._onChange}
            value={value}
          />
          <i>{suffix}</i>
        </div>

        <div
          className={"counter-increase " + maxDisabled}
          onClick={() => {
            this._increase(value);
          }}
        >
          <span>+</span>
        </div>
      </div>
    );
  }
}

export default Counter;
